
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[username]/follow",
      function () {
        return require("private-next-pages/[username]/follow/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[username]/follow"])
      });
    }
  